"use client";

// useFeatureFlags exposes the boolean feature gates declared on the
// organizations table. The endpoint is intentionally cheap (one
// row, no joins) so the command bar can filter handlers in
// O(commands) per render with no per-command round trip.
import useSWR from "swr";
import { useAuth } from "@clerk/nextjs";
import { createFetcher } from "@/lib/api";
import type { FeatureFlag } from "@/lib/commands/types";

export type FeatureMap = Record<FeatureFlag, boolean>;

const emptyFlags: FeatureMap = {
  feature_marketplace_sourcing: false,
  feature_curri_marketplace_fallback: false,
  feature_contractor_payouts: false,
  feature_customer_billing: false,
  feature_dynamic_pricing: false,
};

export function useFeatureFlags() {
  const { getToken } = useAuth();
  const { data, error, isLoading } = useSWR<FeatureMap>(
    "/api/v1/me/features",
    createFetcher(getToken),
    { revalidateOnFocus: false, dedupingInterval: 60_000 },
  );
  return {
    flags: data ?? emptyFlags,
    isLoading,
    error,
  };
}
